module.exports = __webpack_public_path__ + "img/tuv_austria.06512acb.svg";